var map = {
	"./UV-small--.png": "a179",
	"./UV-small-active.png": "9653",
	"./UV-small.png": "6bfb",
	"./dryness.png": "0b3d",
	"./ethnic.png": "b79d",
	"./eye-small.png": "6f96",
	"./eyeNo-small.png": "0401",
	"./flushing.png": "c376",
	"./oily-moderately.png": "9381",
	"./phototype.png": "f06e",
	"./pimples-yes.png": "6284",
	"./question-hover.png": "04d0",
	"./question.png": "f286",
	"./thickness.png": "5734",
	"./wrinkles.png": "7655"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce2b";